//Modules 
import io from 'socket.io-client';

const Socket = (query_object) => {
    //We gt the config of the socket 
    let server = process.env.REACT_APP_API_URL.split('/api')
    // Netlify's reverse-proxy redirect (public/_redirects) fronting the Heroku backend can't
    // upgrade to WebSocket, so this must stay same-origin + polling-only (see tableSessionSocket.js).
    const serverUrl = server[0] || window.location.origin;
    // Connection with the sockets server
    const socket = io(serverUrl,
        {
            transports: ['polling'],
            query: query_object,
            withCredentials: true
        });
    return socket
}

export default Socket;
